import { LocalDate } from '@js-joda/core';

import { AvailabilityRemoveCommand } from '@dreryk/egabinet-appointment-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent } from '@dreryk/react-components';

import { personnelTranslationKeys } from '../../../translations';

type RemoveAvailabilityParameters = { id: number; removeSingleOccurrence: boolean; availabilityDate: LocalDate };

export const useRemoveAvailability = (
   refetchAvailabilities: VoidFunction,
   onSettledAction: () => void,
   practitionerId: PractitionerId
): UseCqrsCommandResult<void, RemoveAvailabilityParameters> => {
   return useCqrsCommand<void, RemoveAvailabilityParameters>(
      (availabilityData) => {
         const command = new AvailabilityRemoveCommand();
         command.practitionerId = practitionerId;
         command.id = availabilityData.id;
         command.removeSingleOccurrence = availabilityData.removeSingleOccurrence;
         command.removingAvailabilityDate = availabilityData.availabilityDate;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(personnelTranslationKeys.successfullyRemovedAvailability);
            refetchAvailabilities();
            onSettledAction();
         },
      }
   );
};
